import {ITheme} from 'contexts/ThemeContext';
import {Platform, useWindowDimensions} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

const FIXED_WIDTH = 419;

export default (props: ITheme, isMyMessage: boolean) => {
  let width = useWindowDimensions().width;
  if (Platform.OS === 'web') {
    width = FIXED_WIDTH;
  }

  return CreateResponsiveStyle(
    {
      container: {
        marginLeft: 16,
        marginRight: 16,
        marginTop: 12,
        marginBottom: 12,
        flexDirection: isMyMessage ? 'row-reverse' : 'row',
      },
      userView: {
        width: 30,
        height: 30,
        borderRadius: 15,
        backgroundColor: props.colors.purple(0.13),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: isMyMessage ? 0 : 12,
        marginLeft: isMyMessage ? 12 : 0,
      },
      contentContainer: {},
      name: {
        fontSize: 10,
        color: props.colors.cornflowerBlue,
      },
      username: {
        ...props.typography.notoSansSemibold,
        fontSize: 14,
      },
      time: {
        fontSize: 12,
        marginRight: 13,
        marginLeft: 13,
        color: props.colors.hitGray,
        ...props.typography.notoSansRegular,
      },
      messageContainer: {
        maxWidth: width - 58 - 58,
        backgroundColor: isMyMessage
          ? props.colors.purple(0.13)
          : props.colors.gallery,
        padding: 10,
        borderTopLeftRadius: isMyMessage ? 16 : 0,
        borderTopRightRadius: isMyMessage ? 0 : 16,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
      },
      message: {
        ...props.typography.notoSansRegular,
      },
      topContentContainer: {height: 34},
      nameTimeContent: {
        top: 6,
        ...(isMyMessage ? {} : {left: 0}),
        ...(isMyMessage ? {right: 0} : {}),
        flexDirection: isMyMessage ? 'row-reverse' : 'row',
        alignItems: 'center',
        position: 'absolute',
        width,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
    },
  )();
};
